import * as React from 'react';
import { Container, Navbar } from 'react-bootstrap';

interface IFooterProps {
}

const Footer: React.FunctionComponent<IFooterProps> = (props) => {
    return (
        <Container className='mt-4 app-footer-wrap' data-bs-theme="dark" fluid="lg">
            <Navbar className="bg-body-tertiary justify-content-center app-footer-bar">
                    <small><b>TNTJ Nerkundram Branch</b></small>
            </Navbar>
        </Container>
    );
};
export default Footer;
